module.exports = __webpack_public_path__ + "img/280f169.png";